omadapp.App = new(function() {
    var t = this;
    var $ = jQuery
    t.getContext = getContext
    t.getInterfaz = getInterfaz
    t.navegar = navegar
    t.layer = layer
    t.getPageController = getPageController
    t.getPageControllers = getPageControllers
    t.getCurrentPageController = getCurrentPageController
    t.getVisitedPages = getVisitedPages
    t.kill = kill
    t.loadPage = loadPage
    t.lanzarEvento = lanzarEvento
    t.cancelNavigation = cancelNavigation
    var genTrans = omadapp.singletons.gestorTransiciones
    var $context
    t.inicializar = inicializar
    var $b = $("body")
    var pages_visited =[]

    var pageControllers = {}
    var pagActual
    var _enableNavigation = true
    var cloneObject = omadapp.singletons.utils.cloneObject
    var $back = $("<div class='js_background'></div>")

    $back.click(function() {
        // cerrarLayer()
    })

    function getPageController(id) {
        return pageControllers[id]
    }
    function getPageControllers() {
        return pageControllers
    }

    function getCurrentPageController() {
        return getPageController(pagActual)
    }

    function inicializar($c, conf) {
        trace("Core::inicializar")
        if (!conf) {
            alert("config no definido")
            return
        }

        $context = $c
        t.config = conf
        omadapp.singletons.siscom.inicializar(conf, salida)



        function salida () {
            meterControladoresdePagina()
            meterInteraccionesGenericas()
            navegar(t.config.arranque)
            lanzarEvento("omadapp.inicializado")
        }

    }


    function kill() {
        $context.empty()
        omada = null
    }


    function meterControladoresdePagina() {
        $context.find(".page").each(function(i, o) {
            var $o = $(o)
            var c = omadapp.controllers[$o.attr("id") + "Controller"]

            if (c) {
                var xx = new c($o)
                pageControllers[$o.attr("id")] = xx
                xx.App = t
                xx.appConfig = t.config
                xx.$page = $o
                if (typeof xx.inicializar === "function") {
                    xx.inicializar()
                }
            } else {

                pageControllers[$o.attr("id")] = { $page: $o }
                trace($o.attr("id") + " Controller no encontrado")
            }
        })
    }
    function getDataNavElement($e) {
        if ($e.attr("data-nav")!=null) {
            return $e
        } else if ($e.parent().length>0){
            return getDataNavElement($e.parent())
        }
        return $e
    }
    function meterInteraccionesGenericas() {
        $b.click(function(e){
            var $e = getDataNavElement($(e.target))
            if ($e.attr("data-nav")!=null) {
                navegar($e.attr("data-nav"), $e.attr("data-trans")||t.config.defaultTransition)
            }
        })
        

        $context.find("[data-layer]").unbind("click")
        $context.find("[data-layer]").click(function(e) {

            var $t = $(this)
            layer($t.attr("data-layer"), $t.attr("data-param"), $t.attr("data-vel"))
        })
        $context.find("[data-trigger]").unbind("click")
        $context.find("[data-trigger]").click(function(e) {

            var $t = $(this)
            trace("me siento clicado")
            trace(this)
            trace("__click." + $t.attr("data-trigger"))
            $("body").trigger("__click." + $t.attr("data-trigger"))
        })
    }

    function loadPage (idPage,variant,callback) {
        var obj = getPage(idPage,variant)
        navegar("loadDynamicPage")

        t.dataPage = obj
        trace (obj.type)
        var gc = pageControllers[obj.type]
        trace (pageControllers)
        gc.$page.attr("data-idpage",idPage)
        $b.off("dynamicPageLoaded").on("dynamicPageLoaded", function() {
            if (callback) {
                callback(gc)
            }
            navegar(obj.type, null, null, function() {
                trace ("marcando juego hecho")
                //trace (ob)

            })
        })

        gc.setData(obj)
    }

    function navegar(id, transicion, params, callback) {

        trace("core::navegar " + id)
        var is_back = false
        if (id=="_back" && pages_visited.length>0) {
            id = pages_visited.pop();
            is_back = true
            transicion = transicion||"slideRight"
        }
        trace (pages_visited)
        trace(pageControllers)
        transicion = transicion || "corte"
        var entrante = getPageController(id)
        var saliente = getPageController(pagActual)
        if (!entrante) {
            console.warn("página "+id+" no encontrada")
            lanzarEvento("omadapp.pagenotfound", [id])
            return
        }
        _enableNavigation = true
        lanzarEvento("omadapp.prenavigation", [id,pagActual])
        if (!_enableNavigation) {
            trace ("navegación cancelada")
            return
        }
        trace(entrante)
        trace(saliente)
        cerrarLayer()
        genTrans.generarTransicion(entrante, saliente, transicion, params, function(entrante, saliente) {
            window["dataLayer"]&&window["dataLayer"].push({
                'event': 'app_subpage',
                "pageTitle": id
            });
            if (callback) {
                callback(entrante, saliente)
            }

            lanzarEvento("omadapp.postnavigation", [id,pagActual])
            if(pagActual&&!is_back&&pagActual!=id) pages_visited.push(pagActual)    
            pagActual = id
        })


    }
    function cancelNavigation() {
        _enableNavigation = false
    }
    function lanzarEvento (str,obj) {
        trace ("Core::lanzarEvento")
        trace (str)
        trace (obj)
        $b.trigger(str,obj)
    }
    function layer(id, param, vel) {
        vel = vel==null?  500: vel
        trace("Main::layer " + id)
        cerrarLayer()
        if (id == "__close") {
            lanzarEvento("omadapp.layer_close",[pagActual])
            trace("sólo cierra layer")
            return
        }
        trace("layer " + id + " -----")
        var $nueva = $("#" + id + ".page");
        if ($nueva.length == 0) {
            trace("la página " + id + " no existe")
            return
        }
        lanzarEvento("omadapp.prelayering",[id])
        var $pagActual = $("#" + pagActual + ".page");
        $nueva.css("opacity", 0)
        $pagActual.addClass("back")
        $nueva.addClass("pop current")
        $nueva.stop().animate({ opacity: 1 }, vel)

        gestionarEntrada(id, param)
        activarLayer(id)
        window["dataLayer"]&&window["dataLayer"].push({
            'event': 'app_layer',
            "pageTitle": id
        });
    }

    function activarLayer(id) {
        if (pageControllers[id] && pageControllers[id].onFront) {
            pageControllers[id].onFront()
        }
    }

    function gestionarEntrada(id, param, pagAnterior) {

        if (pageControllers[id] && pageControllers[id].onCurrent) {
            pageControllers[id].onCurrent(param, pagAnterior)
        }
    }

    function gestionarSalida(id, nueva) {
        if (pageControllers[id] && pageControllers[id].onExit) {
            pageControllers[id].onExit(nueva)
        }
    }

    function cerrarLayer() {
        if ($(".page.pop").length < 1) return;

        gestionarSalida($(".page.pop").attr("id"))
        $(".page.back").removeClass("back")
        var $xx = $(".page.pop")
        $xx.removeClass("pop")
        $xx.stop().animate({ opacity: 0 }, 500, function() {
            $xx.removeClass("current")
        })

    }

    function getInterfaz() {
        return interfaz
    }

    function getContext() {
        return $context
    }

    function getPage (idPage,variant) {
        trace ("core::getPage "+ idPage+" - "+variant)
         var res = cloneObject(t.config.dynamicPages[idPage])
         if (variant&&res.variants[variant]) {
            var variacion = res.variants[variant]
            res = variar (res,variacion)
            //trace ("res ------------")
            //trace (res)
         }
         trace (res)

         return res
    }

    function variar (obj, variant,nivel) {
        nivel == nivel || 0
        if (obj==null) return variant
        for( var n in variant) {
            var vn = variant[n]
            if (vn!=null) {
                if (n[0]!="!"&&(Array.isArray(vn)||(typeof vn === 'object' && vn !== null))) {
                    obj[n] = variar(obj[n],vn,nivel +1)
                } else {
                    obj[n.replace(/^\!/,"")] = variant[n]
                }
            }
        }
        return obj
    }
    function getVisitedPages() {
        return pages_visited
    }
  /// --------------------------------------

  function mostrarAlert(obj) {
    omadapp.singletons.alert.mostrar(obj)
  }

  function mostrarAlert(obj) {
    omadapp.singletons.alert.mostrar(obj)
  }
})